import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { GuestInboxCall, GuestInboxCase, GuestInboxTimelineEvent } from './StayTimeline.types'

export type TimelineItemKind =
  | 'in'
  | 'out'
  | 'ai'
  | 'auto'
  | 'sys'
  | 'call'
  | 'caseOpened'
  | 'caseNote'
  | 'note'

const BUBBLE_KINDS: TimelineItemKind[] = ['in', 'out', 'ai', 'note']

export interface RunFlags {
  isFirst: boolean
  isLast: boolean
}

interface RunCandidate {
  kind: TimelineItemKind
  who?: string | null
}

const continuesRun = (a: RunCandidate | undefined, b: RunCandidate) =>
  !!a && BUBBLE_KINDS.includes(a.kind) && a.kind === b.kind && (a.who ?? '') === (b.who ?? '')

export const getRunFlags = (items: RunCandidate[]): RunFlags[] =>
  items.map((item, index) => ({
    isFirst: !continuesRun(items[index - 1], item),
    isLast: !continuesRun(items[index + 1], item),
  }))

export interface TimelineItem {
  key: string
  kind: TimelineItemKind
  at?: IDate | null
  who?: string | null
  event?: GuestInboxTimelineEvent
  call?: GuestInboxCall
  caseItem?: GuestInboxCase
}
